import React from 'react'
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import { IntervalInputProps } from '../IntervalInputProps'

dayjs.locale('fr')

const ExecutionTimePicker = ({ interval, setInterval }: IntervalInputProps) => {
  const labelInnerText = `Heure d'execution: `
  const any = new Date()
  const currentIntervalHour = parseInt(interval.executionSchedule.executionTime.split(':')[0], 10)
  const currentIntervalMinute = parseInt(interval.executionSchedule.executionTime.split(':')[1], 10)
  any.setHours(currentIntervalHour)
  any.setMinutes(currentIntervalMinute)

  const handleChange = (newValue: dayjs.Dayjs | null) => {
    if (newValue === null || !newValue.isValid()) {
      return
    }
    const newExecutionTime = `${newValue.hour()}:${newValue.minute()}`
    setInterval({
      ...interval,
      executionSchedule: {
        ...interval.executionSchedule,
        executionTime: newExecutionTime,
      },
    })
  }
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="fr"
    >
      <TimePicker
        ampm={false}
        className="w-full"
        label={labelInnerText}
        value={dayjs(any)}
        onChange={(newValue) => handleChange(newValue)}
      />
    </LocalizationProvider>
  )
}

export default ExecutionTimePicker
